import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import securityCodeImage from '../../../../../public/static/books/security-code.png';

import css from './BooksSecurityCodeMessage.module.scss';

interface Props {
  className?: string;
}

const BooksSecurityCodeMessage = ({
  className,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksSecurityCodeMessage, className);

  return (
    <div className={classes}>
      <img
        className={css.BooksSecurityCodeMessage__Img}
        src={securityCodeImage}
        alt="Security Code"
      />
      <p className={css.BooksSecurityCodeMessage__Text}>
        {intl.formatMessage({ id: 'books.paymentMethod.securityCodeMessage' })}
      </p>
    </div>
  );
};

export default injectIntl(BooksSecurityCodeMessage);
